import { IRegister } from "../Auth/types";
import { CartItemType, paymentMethodType } from "../Products/Cart/types";

export interface IUserDataInterface {
  name: string;
  profilePic: string;
  email: string;
  _id: string;
}
export interface IEmail {
  email: string;
  confirmEmail: string;
}

// RETAIL REGISTER
export interface RetailRegister {
  name: string;
  companyName: string;
  postalCode: string;
  prefecture: string;
  village: string;
  streetAddress: string;
  mobileNumber: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export interface IPassword {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}
export interface IOrderList {
  _id: string;
  createdAt: string;
  orderId: string;
  status: OrderStatusType;
  totalPrice: number;
}
export interface INotificationList {
  _id: string;
  japaneseTitle: string;
  title:string;
  notificationType: number;
  createdAt: string;
  updatedAt:string;
}
export interface IOrder {
  _id: string;
  orderId: string;
  createdAt: string;
  updatedAt: string;
  status: OrderStatusType;
  payment_status: string;
  subTotal: number;
  totalShipmentCapacity: number;
  shipmentCharges: number;
  totalPrice: number;
  taxAmount: number;
  firstName: string;
  lastName: string;
  japaneseFirstName: string;
  japaneseLastName: string;
  postCode: string;
  state: string;
  district: string;
  streetAddress: string;
  mobileNumber: string;
  email: string;
  companyName: string;
  japaneseCompanyName: string;
  department: string;
  alternateFirstName: string;
  alternateLastName: string;
  alternateJapaneseFirstName: string;
  alternateJapaneseLastName: string;
  alternatePostCode: string;
  alternateState: string;
  alternateDistrict: string;
  alternateStreetAddress: string;
  alternateMobileNumber: string;
  alternateCompanyName: string;
  alternateJapaneseCompanyName: string;
  alternateDepartment: string;
  remarks: string;
  deliveryTimeSlot: string;
  paymentMethod: paymentMethodType;
  order_items: OrderItem[];
  deliveryCompany: string;
  estimatedDeliveryDate: string;
  trackingUrl: string;
  trackingNo: string;
}

export interface OrderItem {
  _id: string;
  quantity: number;
  price: number;
  featuredImage: string;
  itemType: CartItemType;
  shipmentCapacity: number;
  taxRate: number;
  taxAmount: number;
  category: {
    _id: string;
    title: string;
  };
  product?: {
    _id: string;
    title: string;
  };
  package?: {
    _id: string;
    title: string;
  };
  order_package_items: OrderPackageItem[];
}

export interface OrderPackageItem {
  _id: string;
  availability: number;
  product: Product;
  group: Group;
  productsInGroup: Product[];
}
export interface Product {
  _id: string;
  title: string;
}

export interface Group {
  _id: string;
  title: string;
}
export enum OrderStatusType {
 NULL = 0,
  PENDING = 1,
  WAITING_FOR_ADMIN = 2,
  PROCESSING = 3,
  SUCCESS = 4,
  CANCELLED = 5,
  FAILED = 6,
  ACCEPTED = 7,
  REJECTED = 8,
  HOLD = 9,
  SHIPPED = 10,
  DELIVERED = 11,
  QUEUED_FOR_UN_HOLD = 12,
  READY_FOR_STORE_PICKUP = 13,
}

export interface IHoldUpdatedItem {
  _id: string;
  productId: string;
}
export interface ProfileState {
  password: IPassword;
  registerForm: IRegister;
  emailForm: IEmail;
  loading: boolean;
  buttonLoading: boolean;
  togglePassword: boolean;
  toggleConfirmPassword: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  totalCount: number;
  orderBy: string;
  orderDir: "asc" | "desc";
  orderList: IOrderList[];
  notificationList: INotificationList[];
  orderDetails: IOrder;
  holdUpdatedItems: IHoldUpdatedItem[];
}

export type InitialAuthState = ProfileState;
